export const EWeekDays = {
  None: 0,
  Sunday: 1,
  Monday: 2,
  Tuesday: 4,
  Wednesday: 8,
  Thursday: 16,
  Friday: 32,
  Saturday: 64,
} as const

export type EWeekDays = (typeof EWeekDays)[keyof typeof EWeekDays]

export const WEEKDAY_ORDER: { value: number; labelKey: string }[] = [
  { value: EWeekDays.Sunday, labelKey: "weekday_sunday" },
  { value: EWeekDays.Monday, labelKey: "weekday_monday" },
  { value: EWeekDays.Tuesday, labelKey: "weekday_tuesday" },
  { value: EWeekDays.Wednesday, labelKey: "weekday_wednesday" },
  { value: EWeekDays.Thursday, labelKey: "weekday_thursday" },
  { value: EWeekDays.Friday, labelKey: "weekday_friday" },
  { value: EWeekDays.Saturday, labelKey: "weekday_saturday" },
]
